<template>
    
    <div>           

        <main class="py-0">
            <div class="wrapper">
    <div class="container-fluid">
        <div class="row">
            <div class="login-bg">
                <div class="login-overlay"></div>
                <div class="login-left">
                    <!----<img src="@/lobato/general/img/vertab1.jpg" alt="Logo">-->
                    <p>Iniciar Sesión</p>
                    <!--<a class="btn btn-primary">Ir a página</a>-->
                </div>
            </div>
            <div class="login-form">
                <form method="POST" @submit="iniciar_sesion">

                    <div class="login-form-body">

                        <template v-if="general.otros.conexion_internet.estado">
                            <div class="form-gp">
                                <!-- <label style="pointer-events:none;" for="exampleInputEmail1">Correo electronico</label> -->
                                <input id="email" type="email" class="form-control" name="email" value="" required autocomplete="email" autofocus placeholder="Correo electronico">
                                <i class="ti-email"></i>                            
                                <!-- <span class="invalid-feedback" role="alert">
                                    <strong> Estas credenciales no coinciden con nuestros registros </strong>
                                </span> -->
                            </div>
                            <div class="form-gp">
                                <!-- <label style="pointer-events:none;" for="exampleInputPassword1">Contraseña</label> -->
                                <input id="password" type="password" class="form-control" name="password" required autocomplete="current-password" placeholder="Contraseña">
                                <i class="ti-lock"></i>                            
                                <!-- <span class="invalid-feedback" role="alert">
                                    <strong></strong>
                                </span> -->
                            </div>
                        </template>

                        <div class="row mb-4 rmber-area">
                            <div class="col-6">
                                <!--
                                <div class="custom-control custom-checkbox primary-checkbox mr-sm-2">
                                    <input type="checkbox" class="custom-control-input" name="remember" id="remember" {{ old('remember') ? 'checked' : '' }}>
                                    <label class="custom-control-label" for="remember">{{ __('Recordarme') }}</label>
                                </div>
                                -->  
                            </div>
                            <div class="col-6 text-right">

                            </div>
                        </div>
                        <div class="submit-btn-area">

                            <template v-if="general.otros.conexion_internet.estado">
                                <button type="submit" class="btn btn-primary"> 
                                    Iniciar sesión <i class="ti-arrow-right"></i>
                                </button>
                            </template>


                            <!--<button type="button" class="btn btn-info" style="margin-top:1em;" @click="iniciar_sesion_local"> 
                                Iniciar sin conexion <i class="ti-arrow-right"></i>
                            </button>-->

                            <!-- <div class="login-other row mt-4">
                                <div class="col-6">
                                    <a class="fb-login" href="#"><span class="login_txt">Log in with</span>  <i class="fa fa-facebook"></i></a>
                                </div>
                                <div class="col-6">
                                    <a class="google-login" href="#"><span class="login_txt">Log in with</span>  <i class="fa fa-google"></i></a>
                                </div>
                            </div>-->

                        </div>
                        <div class="form-footer text-center mt-5">
                        
                        </div>
                    </div>
                </form>
                <!-- <button type="button" class="btn btn-info"> 
                    Iniciar sin conexión <i class="ti-arrow-right"></i>
                </button> -->
            </div>
        </div>
    </div>
</div>
        </main>

    </div>

</template>

<script>
/* eslint-disable */
import { mapState } from 'vuex'
import { mapMutations } from 'vuex'
import * as calculos  from '@/librerias/lobato-calculos.js'

export default {
    name: 'com_general',
    props: {
        msg: String
    },
    data() {
    return {
        datos:{
            registro_cargando:false,
            registro:{
                id:'',
                nombre:'',
                tipo:'',
                precio:'',
                descripcion:'',
                imagen:{
                    archivo:'',
                    url:''
                },
                categorias:[]
            },
            body:''
        }
    }
    },
    mounted(){
        this.inicial();
    },
    methods:{
        ...mapMutations(['funciones','alerta']),  
        inicial()
        {
            /* if(this.general.otros.autenticado===true)
            {
                this.obtener_recursos();
                this.data_table();
            }
            else if(this.general.otros.autenticado===false)
            {
                this.$router.push('/login');
            } */
            if(this.general.otros.autenticado===true)
            {
                //window.location.href = `${this.general.otros.dominio}/`;
                this.$router.push('/');
            }
            else
            {            
                this.datos.body=document.body.innerHTML;
                const routerView = this.$el;
                document.body.innerHTML = '';
                document.body.appendChild(routerView);
            }
        },
        iniciar_sesion(e)
        {
            e.preventDefault();
            this.alerta({titulo:'Iniciando',mensaje:'espere ...'});
            fetch(`${this.general.otros.dominio_server}/iniciar_sesion`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                credentials: 'include',
                body: JSON.stringify({ 
                    email   : document.getElementById('email').value,   //'user@example.com', 
                    password: document.getElementById('password').value //'password' 
                })
            })
            //.then(response => response.json())
            .then(res => {
                if (res.status == 200) 
                {
                    return res.json();
                }
                else
                {
                    throw new Error(`Error: ${res.status}`);
                }
            })
            .then(respuesta => {
                console.log('respuesta es');
                console.log(respuesta);                
                let dt={
                    'bien':()=>{
                        localStorage.setItem('app_modo', 'online');
                        //localStorage.setItem('token', respuesta.datos.token);
                        this.general.otros.autenticado_modo='online';
                        this.general.otros.autenticado=true;
                        window.location.href = `${this.general.otros.dominio}/`;

                    },
                    'no encontrado':()=>{
                        this.funciones({nombre:'alerta',estatus:'error',mensaje:`No iniciado`});
                        this.general.otros.autenticado=false;
                    }
                };
                if(respuesta.mensaje in dt)
                {
                    dt[respuesta.mensaje]();
                }
            })
            .catch(error=>{
                this.funciones({nombre:'alerta',estatus:'error',mensaje:`No iniciado`});
                this.general.otros.autenticado=false;
            })
        },
        iniciar_sesion_local()
        {
            //localStorage.setItem('token', '-----');
            localStorage.setItem('app_modo', 'offline');
            window.location.href = `${this.general.otros.dominio}/`;
        }
    },
    computed: {...mapState(['general']) },
}
</script>

<style lang="scss" scoped>

    .login-bg{
        background:url(@/lobato/general/img/reciclaje.jpg) !important;
    }
    
</style>